import React from 'react';
import PropTypes from 'prop-types';
import {FmlxIcon} from 'fmlx-common-ui';
import {PlateType} from 'constants/dataEnum';
import {TouchProbeGuideTooltip} from '../../components/TouchProbeGuideImage';

function PlateViewGuidance({wellNumber, wellShape, wellBottomProfile, plateType}) {
  return (
    <div id="guidance-preview">
      <span className="guidance-preview-content">
        <div>
          <span className="section-title">Guidance</span>
        </div>
        <img
          className="image A"
          alt={`./svg/plate-type-icon/A_Step3_${wellNumber}${wellShape}.svg`}
          src={`./svg/plate-type-icon/A_Step3_${wellNumber}${wellShape}.svg`}
        />
        <span className="image touch-probe">
          <TouchProbeGuideTooltip
            iconStyle={{position: 'relative', top: '-3.82cm', left: '-0.2cm'}}
            placement="right"
          />
          <img
            className="touch-probe-B"
            alt={`./svg/plate-type-icon/B_Step3_${wellBottomProfile}.svg`}
            src={`./svg/plate-type-icon/B_Step3_${wellBottomProfile}.svg`}
          />
          <span className="touch-probe-arrow">
            <FmlxIcon name="ArrowRightAlt" />
          </span>
          <img
            className="touch-probe-C"
            alt={`./svg/plate-type-icon/C_Step3_${plateType === PlateType.SPEAR_BIO ? `${plateType}_` : ''}${wellBottomProfile}.svg`}
            src={`./svg/plate-type-icon/C_Step3_${plateType === PlateType.SPEAR_BIO ? `${plateType}_` : ''}${wellBottomProfile}.svg`}
          />
        </span>
      </span>
    </div>
  );
}

export default PlateViewGuidance;

PlateViewGuidance.propTypes = {
  wellNumber: PropTypes.any.isRequired,
  wellBottomProfile: PropTypes.string.isRequired,
  wellShape: PropTypes.string.isRequired,
  plateType: PropTypes.string.isRequired,
};
